import { format } from 'date-fns';
// @ts-ignore
import memoize from 'nano-memoize';

export const memoizedFormatDate: typeof formatDate = memoize(formatDate);
export function formatDate(date: Date | string | number, dateFormat: string): string {
  return format(new Date(date), dateFormat);
}
